export const enum MutationNames {
  updatePatientWithMappingReports = 'PATIENT_WITH_MAPPING_REPORTS_UPDATE_PATIENT_WITH_MAPPING_REPORTS',
}

export const enum ActionNames {
  getPatientWithMappingReportsById = 'PATIENT_WITH_MAPPING_REPORTS_GET_PATIENT_WITH_MAPPING_REPORTS_BY_ID',
}

export const enum GetterNames {
  patientWithMappingReports = 'PATIENT_WITH_MAPPING_REPORTS_PATIENT_WITH_MAPPING_REPORTS',
}
